import get from 'lodash.get';
import snakeCase from 'lodash.snakecase';
import mapKeys from 'lodash.mapkeys';

import { addShipment } from '../actions/shipments';

export function newPartialShipment(
  productLineId, productLineName, legId, travelerId,
) {
  const { payload } = addShipment({
    productLineId,
    legId,
    travelerId,
    productLineName,
    additionalInfo: '',
    labelId: '',
    insuranceId: '',
    packagingId: '',
  });

  return payload;
}

export function flattenShipment(shipment) {
  const {
    id,
    trackingId,
    shipmentId,
    state,
    legId,
    travelerId,
    additionalInfo,
  } = shipment;

  const productLine = get(shipment, 'label.productLine');

  return {
    id,
    trackingId,
    shipmentId,
    state,
    legId,
    travelerId,
    reactivated: false, // this is only used for traveler shipments
    additionalInfo: additionalInfo || '',
    labelId: get(shipment, 'label.id'),
    insuranceId: get(shipment, 'insurance.id'),
    packagingId: get(shipment, 'packaging.id'),
    productLineId: productLine.id,
    productLineName: productLine.name,
  };
}

export function flattenShipments(shipments) {
  return shipments.map((shipment) => flattenShipment(shipment));
}

export function snakeCaseKeys(shipments) {
  if (shipments === undefined) {
    return [];
  }

  return shipments.map(
    (shipment) => mapKeys(shipment, (value, key) => snakeCase(key)),
  );
}

export function extractTrackingIds(shipments) {
  return shipments.map((shipment) => shipment.trackingId);
}
